import React, { useEffect, useCallback, useState} from 'react';
import {buildRack} from './buildRack.js';
import StepData from "pattern/StepData.js";
import {addEffect} from 'scripting/commands/effects.js';
import {legato} from 'pattern/utils/legato.js';
import {addStep} from 'operations/actions.js';
import {standard, flow} from './definitions.js';

export const useMidiEffect = ({doc, name, sequencerEngine}) => {
    let [effect, setEffect] = useState(undefined);
    let [rack, setRack] = useState(undefined);
    let resolution = sequencerEngine.state.sequencer.displayResolution;
    
    useEffect(() => {
        let track = sequencerEngine.tracks[0];
        track.midiEffects.effects = [];
        let rack = undefined;
        if (flow(name)) {
            rack = addEffect(sequencerEngine, "Midi Effect Rack", undefined, track);
            setRack(rack);
        }  else {
            setRack(undefined);
        }

        let fx = addEffect(sequencerEngine, name, rack, track);
        setEffect(fx);
        track.pattern.clear();
        let {steps, config} = doc;
        if (config) {
            config(fx);
        }

        if (doc.rack) {
            buildRack(sequencerEngine, rack, doc.rack, name);
        }
        track.showEffects(false);

        let i=0;
        for (let s of steps) {
            if (s === undefined) {
                i++;
                continue;
            }
            s = Array.isArray(s) ? s : [s];
            for (let transpose of s) {
                let stepData = new StepData(undefined, undefined, undefined, track);
                stepData.transpose = transpose;
                stepData.on = true;
                sequencerEngine.operationManager.dispatch(
                    addStep(
                        track, stepData, i, resolution, resolution));
            }
            i++;
        }
        legato(track, track.getEasyPattern().getAllSteps());
    }, [name, sequencerEngine, doc]);

    return {effect, rack};
};
